/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - Treff nye folk, chat, sosialiser",
      "Feil telefonnummer",
      "Get the app",
      "Fortsett med Apple",
      "Fortsett med Facebook",
      "Fortsett med Google",
      "Logg inn",
      "Registrer deg",
      "Skriv inn tegnene du ser for å fortsette",
      "Fortsett",
      "Skriv inn tegn",
      "Sikkerhetssjekk",
      "Last på nytt",
      "Lag et nytt passord som du enkelt vil huske:",
      "Oppdater",
      "Bekreft passord",
      "Passordet må være minst {{num}} [[characters:num]]",
      "Passord",
      "Lag nytt passord",
      "Badoo - The Blog",
      "Jobbmuligheter",
      "Chat",
      "Byer",
      "Administrer cookies",
      "Copyright © 2006 – nå. Bumble. Alle rettigheter forbeholdes.",
      "Apple og Apple-logoen er varemerker for Apple Inc.{{__EOL__}}Google Play er et varemerke som eies av Google LLC.",
      "Last ned",
      "Facebook",
      "Følg oss",
      "Hjelpesenter",
      "Instagram",
      "Språk",
      "LinkedIn",
      "Oversikt",
      "Badoo er en del av Bumble Inc.",
      "Personvernerklæring",
      "Safety Centre",
      "Sidekart",
      "Modern Slavery Act statement",
      "Vilkår og betingelser",
      "Twitter",
      "Angi e-posten eller mobilnummeret ditt så sender vi deg instrukser for å lage nytt passord.",
      "Få nytt pasord",
      "Angi e-post eller telefonnummer",
      "Glemt passord",
      "Modeller brukt for illustrasjon",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "Det er ikke nødvendig å vente på en match.{{__EOL__}}{{__EOL__}}Hopp inn i chattene som går litt dypere, og gå rett til de gode tingene. Du vet, den biten hvor dere virkelig blir kjent med hverandre.",
      "Klar for å chatte nå?",
      "Ved å registrere deg godtar du våre <a class=\"link\" href=\"{{terms_url}}\">vilkår og betingelser</a>. Lær mer om hvordan vi bruker dataene dine i vår <a class=\"link\" href=\"{{privacy_url}}\">personvernerklæring</a>",
      "Vi hjelper deg med å vise mer av deg selv,<br /> for dating du føler deg komfortabel med.",
      "Ja til å date med selvtillit.",
      "Eller",
      "Har du allerede en konto?",
      "Registrer deg med e-mail eller telefonnummer",
      "Få det du vil ha ut av dating.{{__EOL__}}Ingen grunn til å beklage,",
      "Vil du bare chatte? Det er OK.{{__EOL__}}Er du klar til å slå deg til ro? Fantastisk.{{__EOL__}}{{__EOL__}}Og hvis du noen gang ombestemmer deg, kan du absolutt det.",
      "Her for dating",
      "Klar for et forhold",
      "Åpen for å chatte",
      "Møt folk som vil det samme.",
      "{{name}}, {{age}}",
      "Din trygghet er vår førsteprioritet",
      "Vårt Safery Centre er et kunnskapssenter som inneholder all støtten du trenger for å date med selvtillit.",
      "Besøk vårt sikkerhetssenter",
      "Trygghet først,<br/>dernest, og alltid.",
      "Fra første øyeblikk trodde jeg dette ville funke...",
      "Først var jeg ikke ute etter noe seriøst...",
      "Et godt råd for alle på Badoo-appen er å være deg selv...",
      "Badoo suksesshistorier",
      "Sjekk ut flere suksesshistorier",
      "{{num}}__CUT__Rating",
      "Apple App Store",
      "Stol på oss. Vi har brakt millioner (og millioner og millioner) av mennesker sammen siden 2006.",
      "{{num}} M+__CUT__Downloads",
      "{{num}} M+",
      "Google Play Store",
      "Vi vet hva vi gjør.",
      "Logg inn med e-post eller telefonnummer",
      "Angi passord",
      "Glemt passord?",
      "Registrer deg",
      "Har du ikke konto?",
      "Innlogging",
      "Registrer deg"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "plural": [
                  "tegn"
            ],
            "singular": [
                  "tegn"
            ]
      },
      "day": {
            "plural": [
                  "dager"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "timer"
            ],
            "singular": [
                  "time"
            ]
      },
      "minute": {
            "plural": [
                  "minutter"
            ],
            "singular": [
                  "minutt"
            ]
      },
      "month": {
            "plural": [
                  "måneder"
            ],
            "singular": [
                  "måned"
            ]
      },
      "second": {
            "plural": [
                  "sekunder"
            ],
            "singular": [
                  "sekund"
            ]
      },
      "year": {
            "plural": [
                  "år"
            ],
            "singular": [
                  "år"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
